import { api } from '../api/client';
import { uploadBlob } from '../api/blobUpload';
import { loadVaultSession } from './vaultSession';
import {
  decryptFolderShareLabel,
  decryptInfoShareLabel,
  encryptFolderShareLabel,
  encryptInfoShareLabel,
  unwrapFolderKeyForMember,
} from './shareLabel';

export async function uploadInfoShareLabel(
  shareId: string,
  label: string,
): Promise<string> {
  const session = loadVaultSession();
  if (!session) {
    throw new Error('vault_locked');
  }

  const encrypted = await encryptInfoShareLabel(session.userPrivateKey, shareId, label);
  return uploadBlob(encrypted);
}

export async function uploadFolderShareLabel(
  folderKey: Uint8Array,
  label: string,
): Promise<string> {
  const encrypted = await encryptFolderShareLabel(folderKey, label);
  return uploadBlob(encrypted);
}

export async function resolveInfoShareLabel(
  shareId: string,
  labelBlobId: string | null | undefined,
): Promise<string | null> {
  if (!labelBlobId) {
    return null;
  }

  const session = loadVaultSession();
  if (!session) {
    return null;
  }

  const blob = await api.fetchBlob(labelBlobId);
  return decryptInfoShareLabel(session.userPrivateKey, shareId, blob);
}

export async function resolveFolderShareLabel(
  folderId: string,
  wrappedFolderKey: string,
  labelBlobId: string | null | undefined,
): Promise<string | null> {
  if (!labelBlobId) {
    return null;
  }

  const session = loadVaultSession();
  if (!session) {
    return null;
  }

  const folderKey = await unwrapFolderKeyForMember(
    wrappedFolderKey,
    folderId,
    session.userPrivateKey,
  );
  const blob = await api.fetchBlob(labelBlobId);
  return decryptFolderShareLabel(folderKey, blob);
}
